import { apiCallCenter } from '@/plugins/axios'

export default {
  getDepartamentos() {
    return apiCallCenter().get('/departamentos')
  },

  getDepartamentoEspecifico(id) {
    return apiCallCenter().get(`/departamentos/${id}`)
  },
  getDepartamentoUse(id) {
    return apiCallCenter().get(`/departamentos/use/${id}`)
  },

  postDepartamento(form) {
    return apiCallCenter().post('/departamentos', form)
  },

  putDepartamento(id, form) {
    return apiCallCenter().put(`/departamentos/${id}`, form)
  },

  deleteDepartamento(id) {
    return apiCallCenter().delete(`/departamentos/${id}`)
  },

  getOperadores() {
    return apiCallCenter().get('/departamentos/agentes/lazy')
  },
}
